import { useSortBy } from "react-instantsearch";
import { useTranslations } from "next-intl";

export const useAlgoliaSortBy = () => {
  const t = useTranslations("Products-list.filters");
  const { currentRefinement, refine, canRefine, initialIndex, options } =
    useSortBy({
      items: [
        // { label: "-", value: "products" },
        { label: t("order-asc"), value: "products_price_asc" },
        { label: t("order-desc"), value: "products_price_desc" },
      ],
    });

  return {
    currentRefinement,
    refine,
    canRefine,
    initialIndex,
    options,
  };
};
